import script from "./EventTile.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventTile.vue?vue&type=script&lang=ts&setup=true"

import "./EventTile.vue?vue&type=style&index=0&id=62624881&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62624881"]])

export default __exports__